export default __webpack_public_path__ + "static/media/mastercard.d171db25.svg";